/**
 * Confirm exchange — same confirmation shell as confirm-sale.
 */
import React from 'react';
import { SwapHoriz as SwapHorizIcon } from '@mui/icons-material';
import { ConfirmationModal } from '../../ui/Modal';

export interface ConfirmExchangeConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const ConfirmExchangeConfirmationModal: React.FC<ConfirmExchangeConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}): React.ReactElement => (
  <ConfirmationModal
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    title="¿Confirmar este intercambio?"
    message="Se procesará el intercambio, se actualizará el inventario y se registrarán los pagos de la diferencia si aplica."
    confirmText="Confirmar"
    cancelText="Volver"
    variant="default"
    loading={loading}
    icon={<SwapHorizIcon />}
  />
);

export default ConfirmExchangeConfirmationModal;
